import { useMemo } from 'react';
import 'dayjs/locale/es';
import 'dayjs/locale/pt';
import 'dayjs/locale/pt-br';
import 'dayjs/locale/en';
import { useConfig } from '../providers/ConfigProvider';
import {
  resolveDateFormattingLocale,
  bcp47ToDayjsLocale,
  getDayjsDateFormatForLocale,
} from '../utils/lib';

/** Locale + format for MUI DatePickers in reports (region of the clinic, like MainDailyCash). */
export function useReportDatePickerLocale() {
  const { config } = useConfig();
  const dateFormattingLocale = useMemo(() => resolveDateFormattingLocale(config), [config]);
  const datePickerFormat = useMemo(
    () => getDayjsDateFormatForLocale(dateFormattingLocale),
    [dateFormattingLocale]
  );
  const dayjsPickerLocale = useMemo(
    () => bcp47ToDayjsLocale(dateFormattingLocale),
    [dateFormattingLocale]
  );
  return { datePickerFormat, dayjsPickerLocale };
}
